var tracker =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Tracker = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _datalayer = __webpack_require__(284);
	
	var _yandexMetrika = __webpack_require__(285);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * На бекенде инициализируется набор данных для аналитики. Будем использовать его в качестве контейнера для хранения
	 * данных и будем раздавать оттуда данные для аналитических сервисов и CPA партнеров
	 */
	var Tracker = exports.Tracker = function () {
	    function Tracker(data) {
	        _classCallCheck(this, Tracker);
	
	        this.data = data;
	        this.dataLayer = new _datalayer.DataLayerTracker(data);
	        this.yandexMetrika = new _yandexMetrika.YandexMetrika();
	
	        this.init();
	        this.backendPageViewed();
	    }
	
	    _createClass(Tracker, [{
	        key: 'init',
	        value: function init() {
	            this.dataLayer.init();
	        }
	    }, {
	        key: 'backendPageViewed',
	        value: function backendPageViewed() {
	            try {
	                switch (this.data.route) {
	                    case 'index':
	                        this.indexPageViewed();
	                        break;
	                    case 'catalog':
	                        this.catalogPageViewed();
	                        break;
	                    case 'catalog_products':
	                        this.categoryPageViewed();
	                        break;
	                    case 'catalog_product':
	                        this.productPageViewed();
	                        break;
	                    case 'cart':
	                        this.cartPageViewed();
	                        break;
	                    case 'order':
	                        this.orderPageViewed();
	                        break;
	                    // это фейковый маршрут, но страница эта отдельная
	                    case 'order.thankyoupage':
	                        this.orderThankyouPageViewed();
	                        break;
	                    default:
	                        this.otherPageViewed();
	                        break;
	                }
	            } catch (e) {
	                console.log(e);
	            }
	        }
	    }, {
	        key: 'otherPageViewed',
	        value: function otherPageViewed() {}
	    }, {
	        key: 'indexPageViewed',
	        value: function indexPageViewed() {
	            this.dataLayer.categoryPageView(this.data.products);
	        }
	    }, {
	        key: 'catalogPageViewed',
	        value: function catalogPageViewed() {
	            this.dataLayer.categoryPageView(this.data.products);
	        }
	    }, {
	        key: 'categoryPageViewed',
	        value: function categoryPageViewed() {
	            this.dataLayer.categoryPageView(this.data.products);
	        }
	    }, {
	        key: 'productPageViewed',
	        value: function productPageViewed() {
	            this.dataLayer.productPageView(this.data.product);
	        }
	    }, {
	        key: 'cartPageViewed',
	        value: function cartPageViewed() {
	            this.dataLayer.cartPageView(this.data.basket);
	        }
	    }, {
	        key: 'orderPageViewed',
	        value: function orderPageViewed() {
	            this.dataLayer.orderPageView(this.data.basket);
	        }
	
	        /**
	         *  Вот это по сути страница оплаты
	         */
	
	    }, {
	        key: 'orderThankyouPageViewed',
	        value: function orderThankyouPageViewed() {
	            this.dataLayer.orderThankyouPageView(this.data.order, this.data.basket);
	        }
	
	        /*basketItemAddClicked() {
	            this.dataLayer.push({'event': 'Add2Cart_Button'});
	        }*/
	
	        /**
	         *  рабочий
	         *  window.emiliadelloroShopTracker.basketItemAdded(product);
	         * @param product
	         */
	
	    }, {
	        key: 'basketItemAdded',
	        value: function basketItemAdded(product) {
	            this.dataLayer.basketItemAdd(product);
	        }
	    }, {
	        key: 'basketItemRemoved',
	        value: function basketItemRemoved(product) {
	            this.dataLayer.basketItemRemove(product);
	        }
	    }, {
	        key: 'catalogProductClick',
	        value: function catalogProductClick() {
	            var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            if (product.length === 0) {
	                console.log('Error push dataLayer catalogProductClick: empty data product');
	                return;
	            }
	            this.dataLayer.catalogProductClick(product);
	        }
	    }, {
	        key: 'isUserAuthorized',
	        value: function isUserAuthorized() {
	            return this.data.user.authorized;
	        }
	    }, {
	        key: 'getCurrency',
	        value: function getCurrency() {
	            return this.data.currency;
	        }
	    }]);

	    return Tracker;
	}();

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var dataLayerInited = false;
	
	var DataLayerTracker = exports.DataLayerTracker = function () {
	    function DataLayerTracker(data) {
	        _classCallCheck(this, DataLayerTracker);
	
	        this.dataLayer = this.init(data);
	        console.log(data);
	    }
	
	    /**
	     * Инициализируем начальный dataLayer
	     * @param data
	     * @returns {*|Array}
	     */
	
	
	    _createClass(DataLayerTracker, [{
	        key: 'init',
	        value: function init() {
	            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            window.dataLayer = window.dataLayer || [];
	            if (dataLayerInited) {
	                return window.dataLayer;
	            }
	
	            var initialLayer = {
	                isLogged: data.user.authorized
	            };
	
	            // if (initialLayer.isLogged) {
	            //     initialLayer.user = {
	            //         birthdate: data.user.born_at ? data.user.born_at.short : 'unknown',
	            //         gender: data.user.gender ? data.user.gender : 'unknownn',
	            //         regDate: data.user.registered_at.short
	            //     };
	            // }
	
	            switch (data.route) {
	                case 'index':
	                    initialLayer.pagetype = 'main';
	                    break;
	                case 'catalog_products':
	                    initialLayer.pagetype = 'catalog';
	                    break;
	                case 'catalog_product':
	                    initialLayer.pagetype = 'product';
	                    break;
	                case 'order':
	                    initialLayer.pagetype = 'order';
	                    break;
	                case 'order.thankyoupage':
	                    initialLayer.pagetype = 'confirmation';
	                    break;
	                case '404':
	                    initialLayer.pagetype = '404';
	                    break;
	                default:
	                    initialLayer.pagetype = 'other';
	                    break;
	            }
	
	            window.dataLayer.push(initialLayer);
	
	            dataLayerInited = true;
	            return window.dataLayer;
	        }
	    }, {
	        key: 'push',
	        value: function push(layer) {
	            this.dataLayer.push(layer);
	        }
	    }, {
	        key: 'categoryPageView',
	        value: function categoryPageView(products) {
	
	            //https://yandex.ru/support/metrica/ecommerce/data.html
	            this.push({ ecommerce: null });
	            this.push({
	                'event': 'impressions',
	                "ecommerce": {
	                    "currencyCode": "RUB",
	                    "impressions": products
	                    //products
	                    /*"impressions": [
	                        {
	                            "id": "P15432",
	                            "name" : "Футболка",
	                            "price": 477.60,
	                            "brand": "Яндекс / Яndex",
	                            "category": "Одежда/Мужская одежда/Футболки",
	                            "variant" : "Красный цвет",
	                            "list": "Search",
	                            "position": 1
	                        },
	                        {
	                            "id": "P15435",
	                            "name" : "Футболка",
	                            "price": 500.60,
	                            "brand": "Яндекс / Яndex",
	                            "category": "Одежда/Мужская одежда/Футболки",
	                            "variant" : "Синий цвет",
	                            "list": "Search",
	                            "position": 2
	                        }
	                    ]*/
	                }
	            });
	
	            // #18588 Событие используется для Criteo счетчика. Туда нужно передавать только три первых товара из списка
	            /*const productIds = products.map((product) => {
	                return product.id;
	            });
	             this.push({
	                'event': 'viewList',
	                'item': productIds.slice(0, 3)
	            });*/
	        }
	    }, {
	        key: 'productPageView',
	        value: function productPageView(product) {
	            this.push({ ecommerce: null });
	            this.push({
	                event: 'detail',
	                ecommerce: {
	                    detail: {
	                        products: {
	                            id: product.id,
	                            name: product.name,
	                            price: parseFloat(product.price),
	                            brand: product.vendor,
	                            category: product.category
	                        }
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'basketItemAdd',
	        value: function basketItemAdd(product) {
	            this.push({ ecommerce: null });
	            this.push({
	                'event': 'addToCart',
	                'ecommerce': {
	                    'currencyCode': 'RUB',
	                    'add': {
	                        'products': collectBasketItems([product])
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'basketItemRemove',
	        value: function basketItemRemove(product) {
	            this.push({ ecommerce: null });
	            this.push({
	                event: 'remove',
	                ecommerce: {
	                    'currencyCode': 'RUB',
	                    'remove': {
	                        'products': collectBasketItems([product])
	                    }
	                }
	            });
	        }
	
	        // basketPageView(basket) {
	        //     this.push({
	        //         'ecommerce': {
	        //             'checkout': {
	        //                 'actionField': {'step': 1},
	        //                 'products': collectBasketItems(basket)
	        //             }
	        //         }
	        //     });
	        //
	        //     this.push({
	        //         'event' : 'ecommerceCheckout',
	        //         'ecommerce': {
	        //             'checkout': {
	        //                 'actionField': {'step': 1},
	        //                 'products': collectBasketItems(basket)
	        //             }
	        //         }
	        //     });
	        // }
	
	    }, {
	        key: 'cartPageView',
	        value: function cartPageView(basket) {
	            this.push({ ecommerce: null });
	            this.push({
	                'event': 'checkout_step_1',
	                'ecommerce': {
	                    'checkout': {
	                        'actionField': {
	                            'step': 1,
	                            'option': 'Cart'
	                        },
	                        'products': collectBasketItems(basket)
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'orderPageView',
	        value: function orderPageView(basket) {
	            this.push({ ecommerce: null });
	            this.push({
	                'event': 'checkout_step_2',
	                'ecommerce': {
	                    'checkout': {
	                        'actionField': {
	                            'step': 2,
	                            'option': 'Checkout'
	                        },
	                        'products': collectBasketItems(basket)
	                    }
	                }
	            });
	        }
	
	        // orderPageReload(basket) {
	        //     this.push({'ecommerce': {
	        //         'checkout': {
	        //             'actionField': {'step': 3},
	        //             'products': collectBasketItems(basket)
	        //         }
	        //     }});
	        //
	        //     this.push({
	        //         'event' : 'ecommerceCheckout',
	        //         'ecommerce': {
	        //             'checkout': {
	        //                 'actionField': {'step': 3},
	        //                 'products': collectBasketItems(basket)
	        //             }
	        //         }
	        //     });
	        // }
	
	        /*orderPageLoyalityCardValidtion(card) {
	            this.push({
	                'event': 'checkoutOption',
	                'ecommerce': {
	                    'checkout_option': {
	                        'actionField': {'step': 2, 'option': 'подтвердил пин код бонусной карты'},
	                        'card1' : card.number,
	                        'card2' : card.pin
	                    }
	                }
	            })
	        }*/
	
	    }, {
	        key: 'orderThankyouPageView',
	        value: function orderThankyouPageView(order, basket) {
	            this.push({ ecommerce: null });
	            this.push({
	                'event': 'purchase',
	                'ecommerce': {
	                    'currencyCode': 'RUB',
	                    'purchase': {
	                        'actionField': {
	                            id: order.id,
	                            affiliation: window.location.host,
	                            revenue: order.price,
	                            tax: order.tax,
	                            shipping: order.delivery_price,
	                            coupon: order.coupon
	                        },
	                        'products': collectBasketItems(basket)
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'catalogProductClick',
	        value: function catalogProductClick(product) {
	            this.push({ ecommerce: null });
	            this.push({
	                "event": "productClick",
	                "ecommerce": {
	                    "currencyCode": "RUB",
	                    "click": {
	                        "products": [product]
	                    }
	                }
	            });
	
	            //dataLayer.push({
	            //     "ecommerce": {
	            //         "currencyCode": "RUB",
	            //         "click": {
	            //             "products": [
	            //                 {
	            //                     "id": "39084",
	            //                     "name": "Термостакан Яндекс",
	            //                     "price": 1089.69,
	            //                     "brand": "Яндекс / Яndex",
	            //                     "category": "Товары для дома/Посуда/Термосы и термокружки",
	            //                     "variant": "Красный цвет",
	            //                     "list": "Search",
	            //                     "position": 1
	            //                 }
	            //             ]
	            //         }
	            //     }
	            // });
	        }
	    }]);
	
	    return DataLayerTracker;
	}();
	
	var collectBasketItems = function collectBasketItems(basket) {
	    var items = [];
	    basket.forEach(function (basketItem) {
	        items.push(formatBasketItem(basketItem));
	    });
	    return items;
	};
	var formatBasketItem = function formatBasketItem(product) {
	    if (!product) {
	        return {};
	    }
	
	    return {
	        id: product.id,
	        name: product.name,
	        price: product.price,
	        category: product.category,
	        quantity: product.quantity
	        //variant: '',
	        //brand: product.vendor,
	    };
	};
	
	var formatBasketItemGa4 = function formatBasketItemGa4(product) {
	
	    if (!product) {
	        return {};
	    }
	
	    return {
	        item_name: product.name,
	        item_id: product.id,
	        price: product.price,
	        item_brand: product.vendor,
	        item_category: product.category,
	        quantity: product.quantity
	    };
	};
	var collectBasketItemsGa4 = function collectBasketItemsGa4(basket) {
	    var items = [];
	    basket.forEach(function (basketItem) {
	        items.push(formatBasketItemGa4(basketItem));
	    });
	    return items;
	};

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.YandexMetrika = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webpack = __webpack_require__(286);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var YandexMetrika = exports.YandexMetrika = function () {
	    function YandexMetrika() {
	        _classCallCheck(this, YandexMetrika);
	    }
	
	    _createClass(YandexMetrika, [{
	        key: 'track',
	        value: function track(code, eventCode) {
	            try {
	                if (typeof window.ym != 'undefined') {
	                    window.ym(67203277, code, eventCode);
	                }
	            } catch (e) {
	                if (_webpack.isDevelopment) {
	                    console.log('Ошибка ' + e.name + ':' + e.message + '\n' + e.stack);
	                }
	            }
	        }
	    }, {
	        key: 'timeClient',
	        value: function timeClient() {
	            this.track('reachGoal', 'time_more_than_x');
	        }
	
	        /**
	         *  вот эта тема не работает, так как яндекс либа не успевала загружаться
	         *  по этому вставили этот метод сразу в сенькю пейд в футер
	         */
	
	    }, {
	        key: 'orderComplete',
	        value: function orderComplete() {
	            this.track('reachGoal', 'order_complete');
	        }
	    }, {
	        key: 'notFountPage',
	        value: function notFountPage() {
	            this.track('reachGoal', 'mn_error_404');
	        }
	    }, {
	        key: 'userAuthorized',
	        value: function userAuthorized(user) {
	            var userParams = { userId: user.USER_ID };
	            this.track('userParams', userParams);
	            this.track('params', userParams);
	            this.track('setUserID', user.USER_ID);
	        }
	    }]);

	    return YandexMetrika;
	}();

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var NODE_ENV = process.env.NODE_ENV || 'development';
	var isDevelopment = NODE_ENV === 'development';
	var isProduction = NODE_ENV === 'production';
	
	module.exports = {
	    NODE_ENV: NODE_ENV,
	    isDevelopment: isDevelopment,
	    isProduction: isProduction
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(287)))

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ })

/******/ });


// WEBPACK FOOTER //
// js/tracker.a22cb9d4681b9f31a36b.js